//
// client-exceptions-service.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').service('ClientExceptionsService', ['$http', '$q',
        function ($http, $q) {
            this.getExceptionSummary = (start, end) => processResponse(
                $http.get('/exceptions',
                    { params: { start, end } }
                )
            );

            this.getExceptionDetails = (type, start, end, page, sortBy, sortReverse, q) => {
                if (!page) {
                    page = 1;
                }

                const params = { start, end, offset: page - 1, pageSize: 100 };
                if (q) {
                    params.q = q;
                }
                if (sortBy) {
                    params.sortBy = sortBy;
                    params.sortDir = sortReverse ? 'desc' : 'asc';
                }

                return processResponse(
                    $http.get(`/exceptions/${type}`,
                        { params }
                    )
                );
            };

            function processResponse(httpPromise) {
                const deferred = $q.defer();

                httpPromise.then(response => {
                    deferred.resolve(response.data);
                }, response => {
                    const error = response.data;
                    if (typeof error.message !== 'undefined') {
                        deferred.reject(error.message);
                    } else {
                        deferred.reject(error);
                    }
                });

                return deferred.promise;
            }
        },
    ]);
}))();
